var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4115 5.0492L16.9839 31.1495C16.686 31.6884 15.9207 31.6915 15.6183 31.1553L0.904743 5.05163C0.575295 4.46733 1.06923 3.75947 1.7238 3.87793L16.1669 6.48956C16.259 6.50622 16.3534 6.50605 16.4454 6.48908L30.5864 3.88157C31.2388 3.76129 31.735 4.46369 31.4115 5.0492Z",
    fill: "url(#paint0_linear_1_5765)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0468 0.452103L12.37 2.56865C12.2847 2.58555 12.2074 2.63067 12.1502 2.69689C12.093 2.76311 12.0592 2.84668 12.054 2.93447L11.3973 14.1564C11.3937 14.2179 11.4043 14.2795 11.4283 14.3361C11.4523 14.3928 11.4891 14.443 11.5356 14.4828C11.5821 14.5226 11.6372 14.5509 11.6965 14.5654C11.7557 14.5799 11.8174 14.5802 11.8768 14.5664L14.8494 13.8723C15.1275 13.8074 15.3789 14.0553 15.3216 14.3382L14.4385 18.7134C14.3791 19.0079 14.6523 19.2596 14.9365 19.1722L16.7726 18.6079C17.0572 18.5205 17.3307 18.773 17.2705 19.0677L15.867 25.9401C15.7792 26.37 16.3444 26.6044 16.5801 26.2359L16.7376 25.9897L25.4376 8.42428C25.5834 8.13019 25.332 7.79483 25.0129 7.85722L21.953 8.45463C21.6655 8.5107 21.4209 8.23979 21.502 7.95529L23.4991 0.95132C23.5803 0.666087 23.3347 0.395056 23.0469 0.452103H23.0468Z",
    fill: "url(#paint1_linear_1_5765)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_5765",
    x1: 0.545499,
    y1: 5.98372,
    x2: 16.3406,
    y2: 27.1873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD34FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_5765",
    x1: 17.5054,
    y1: 1.02679,
    x2: 20.7801,
    y2: 23.2306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.083,
    stopColor: "#FFDD35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVite);
export default __webpack_public_path__ + "static/media/vite.777d2bb01bfbc3efdd286ef0d42e0c81.svg";
export { ForwardRef as ReactComponent };